import HyperLink from "src/components/atoms/hyper-link/hyper-link";
import { ReactComponent as LogoutIcon } from "../../../assets/svg/logoutIcon.svg";
import { useAuth } from "src/components/organisms/auth/auth-context";

const LogoutLinkButton = () => {
	const { logout } = useAuth();

	return (
		<div className="flex items-center justify-end gap-2">
			<HyperLink href={""} onClick={logout} label={"logout"}></HyperLink>
			<LogoutIcon className="w-4 h-4 text-blue-600 font-semibold"></LogoutIcon>
		</div>
	);
};

export default LogoutLinkButton;
